<script lang="ts">
  import DistributorPlpRetailerUserAuthentication from "@shared/svelte/Components/ProductLines/DistributorPlpRetailerUserAuthentication.svelte";
  import { Button, Icon } from "@getprovi/craft-svelte";
  import { BoxArrowUpRight } from "@getprovi/craft-svelte-icons";
  import { loginEvent } from "@shared/services/retailer_user_authentication_service";
  import { VT_802_SPIRITS_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  export let authStatus: string;
  export let authService: any;
  export let mobileMode: boolean;
</script>

<div class="craft" data-testid="vermont-plp-cta">
  <DistributorPlpRetailerUserAuthentication {authStatus} {mobileMode}>
    <div slot="invalid-title">We can’t verify your myVermont DLL account.</div>

    <div slot="invalid-description">
      If there are issues, please call the Vermont Department of Liquor and Lottery at <a
        href="tel:+18028282345">802-828-2345</a
      >.
    </div>

    <div slot="invalid-buttons">
      <a
        href={authService.loginUrl()}
        target="_blank"
        rel="noreferrer"
        class="craft-button btn-primary btn-base justify-center"
        style="border-radius: 32px;"
        on:click={() => {
          loginEvent(authStatus, VT_802_SPIRITS_DISTRIBUTOR_ID);
          authService.refresh();
        }}
        data-testid="reconnect-account-button"
      >
        <span class="btn-text flex gap-4">Verify Account <Icon iconName={BoxArrowUpRight} /></span>
      </a>
    </div>

    <div slot="invalid-mobile-buttons">
      <div class="fizz-flex-row fizz-justify-center">
        <a
          href="https://app.provi.com/"
          target="_blank"
          rel="noreferrer"
          class="craft-button btn-primary btn-base justify-center"
          style="border-radius: 32px;"
          on:click={() => {
            loginEvent(authStatus, VT_802_SPIRITS_DISTRIBUTOR_ID);
            authService.refresh();
          }}
        >
          <span class="btn-text flex gap-4">Verify Account <Icon iconName={BoxArrowUpRight} /></span
          >
        </a>
      </div>
    </div>

    <div slot="pending-title"> Access High Proof Spirits & Liquor! </div>

    <div slot="pending-description">
      Use your myVermont DLL Account to access products from Vermont!
    </div>

    <div slot="pending-buttons">
      <Button size="sm" on:click={() => authService?.startVerification?.(authStatus)}
        >Verify Account</Button
      >
    </div>
  </DistributorPlpRetailerUserAuthentication>
</div>
